import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import {
  Add
} from "@mui/icons-material";
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  SmartHash,
} from "@models";
import {  
  MagicItemKeyword, 
  CharacterLimitation,
  Item,
  WeaponLimitation,
  // Recipe,
  // RecipeComponent,
  // CampaignRecipe,
  SpellLimitation,
  Limitations,
  ARMOR_TYPE_OPTIONS,
  WEAPON_KEYWORD_OPTIONS,
  UpgradableNumber,
} from "@dndModels";
import { 
  ITEM_TYPES, 
  SCHOOLS, 
  ABILITY_SCORES,
  DAMAGE_TYPES,
  DRAGON_TYPES,
  ALL_DRAGONS,
  CREATURE_TYPES,
  RARITY_OPTIONS,
  RARITY_NUM_TO_STR_MAP,
  REFRESH_RULES,
  EXTRA_BASE_TYPES
} from "@dndModels/Constants";
import { DamageType, ExtraBaseType, ItemType, RefreshRuleType } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";

import SelectArmorTypeBox from "@dndComponents/select/SelectArmorTypeBox";
import SelectBaseItemBox from "@dndComponents/select/SelectBaseItemBox";

import SelectObjectFieldBox from "@components/input/selects/SelectObjectFieldBox";
import LoadingBox from "@components/input/LoadingBox";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import CharacterLimitationBox from "@dndComponents/limitations/CharacterLimitationBox";
import DisplayObjects from "@dndComponents/display/DisplayObjects";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import AddButton from "@components/input/buttons/AddButton";
import DeleteButton from "@components/input/buttons/DeleteButton";
import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";
import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function MagicItemKeywordEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<MagicItemKeyword>(api.applyWorkingOn(new MagicItemKeyword()));
  const [change_time, setChangeTime] = useState(0);
  const [ping, setPing] = useState(false);
  const [recalc_possible, setRecalcPossible] = useState(false);
  const [possible_base_item_ids, setPossibleBaseItemIds] = useState<string[]>([]);
  const [adding_name_for_rarity, setAddingNameForRarity] = useState("");
  // const [recipe_view, setRecipeView] = useState("Standard");
  // const [changed_campaign_recipe, setChangedCampaignRecipe] = useState<CampaignRecipe | null>(null);
  // const [campaign_recipe, setCampaignRecipe] = useState<CampaignRecipe | null>(null);
  // const [using_standard, setUsingStandard] = useState(false);
  const [items, setItems] = useState<Item[]>([]);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
    
  useEffect(() => {
    if (recalc_possible) {
      setRecalcPossible(false);
      // debugger;
      const new_possible_base_item_ids = items.filter(o => api.doesMIKFitItem(obj, o)).map(o => o._id);
      setPossibleBaseItemIds(new_possible_base_item_ids);
    }
  }, [obj, recalc_possible, setRecalcPossible, setPossibleBaseItemIds, items]);

  const load = () => {
    setLoading(true);
    const onComplete = (res: SmartHash) => {
      if (res.item) {
        setItems(res.item as Item[]);
      }
      if (res.magic_item_keyword) {
        if (id && id !== "") {
          const new_obj = res.magic_item_keyword.find(o => o._id === id);
          if (new_obj) {
            setObj(new_obj.clone() as MagicItemKeyword);
            setChangeTime(common_util.get_time_number());
          }
          setRecalcPossible(true);
          // if (api.recipes_for_campaign) {
          //   setRecipeView("Campaign");
          //   api.getPlayerObjects({ data_type: "campaign_recipe", filter: { campaign_id: api.recipes_for_campaign._id, item_id: id } }).then(res => {
          //     if (res && res.length > 0 && res[0] instanceof CampaignRecipe) {
          //       setChangedCampaignRecipe(res[0].clone());
          //       setCampaignRecipe(res[0].clone());
          //     } else {
          //       setChangedCampaignRecipe(new CampaignRecipe());
          //       setCampaignRecipe(new CampaignRecipe());
          //     }
          //     setLoading(false);
          //   });
          // } else {
            setLoading(false);
          // }
        } else {
          setLoading(false);
        }
      }
    }

    const onProgress = () => {};
    api.getSetOfObjectsWithCallbacks({ 
      data_types: ["item","magic_item_keyword"],
      onComplete, onProgress 
    });
    setFetched(true);
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("magic_item_keyword", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/magic_item_keyword");
  //     });
  //   }
  // }

  const renderExtraLimits = () => {
    if (obj.extra_base_type === "Spell") {
      const limits = obj.extra_base_limit.limits;
      if (limits.length === 1 && limits[0] instanceof SpellLimitation) {
        const spell_limit = limits[0];
        return (
          <SpellLimitInput
            obj={spell_limit} 
            disabled={disabled}
            onChange={(changed: SpellLimitation) => {
              const new_obj = obj;
              const limits = new_obj.extra_base_limit.limits;
              if (limits.length === 1 && limits[0] instanceof SpellLimitation) {
                const spell_limit = limits[0];
                spell_limit.copy(changed);
              }
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        );
      }
      // const extra_base_limits = obj.extra_base_limits as { levels: string[], schools: string[], onSpellList: string[] };
      // return (
      //   <Grid item container spacing={0} direction="row">
      //     <Grid item xs={6}>
      //       <SelectStringBox
      //         name="Spell Levels"
      //         values={extra_base_limits.levels}
      //         options={[
      //           "Any",
      //           ...SPELL_LEVELS
      //         ]}
      //         disabled={disabled}
      //         multiple
      //         onChange={(values: string[]) => {
      //           const new_obj = obj;
      //           new_obj.extra_base_limits.levels = values;
      //           setObj(new_obj);
      //         }}
      //       />
      //     </Grid>
      //     <Grid item xs={6}>
      //       <SelectStringBox
      //         name="Schools"
      //         values={extra_base_limits.schools}
      //         options={[
      //           "Any",
      //           ...SCHOOLS
      //         ]}
      //         disabled={disabled}
      //         multiple
      //         onChange={(values: string[]) => {
      //           const new_obj = obj;
      //           new_obj.extra_base_limits.schools = values;
      //           setObj(new_obj);
      //         }}
      //       />
      //     </Grid>
      //   </Grid>
      // );
    } else if (obj.extra_base_type !== "None") {
      const extra_base_limits = obj.extra_base_limits;
      let options = ["Any"];
      let label = "";
      switch(obj.extra_base_type) {
        case "Ability Score":
          label = "Ability Scores";
          options = ABILITY_SCORES;
        break;
        case "Damage Type":
          label = "Damage Types";
          options = DAMAGE_TYPES;
        break;
        case "School of Magic":
          label = "Schools";
          options = SCHOOLS;
        break;
        case "Dragon Type":
          label = "Dragon Types";
          options = DRAGON_TYPES;
        break;
        case "Dragon Breed":
          label = "Dragon Breeds";
          options = ALL_DRAGONS;
        break;
        case "Creature Type":
          label = "Creature Types";
          options = CREATURE_TYPES;
        break;
        // case "Strings":

        // break;
        // case "Spell List":
        //   options = [
        //     "Any",
        //     ...DAMAGE_TYPES
        //   ];
        // break;
      }
      return (
        <Grid container spacing={0} direction="row">
          <SelectStringBox
            name={label}
            values={extra_base_limits}
            options={options}
            disabled={disabled}
            multiple
            allow_all
            allow_none
            onChange={(values: string[]) => {
              const new_obj = obj;
              new_obj.extra_base_limits = values;
              setObj(new_obj);
            }}
          />
        </Grid>
      );
    }
    return null;
  }

  const renderDetails = () => {
    if (obj.uses_specific) {
      const use_items = items.filter(o => obj.base_item_ids.includes(o._id));
      const item_types = common_util.unique_array(use_items.map(o => o.item_type));
      if (item_types.includes("Armor")) {
        return renderArmorDetails();
      } else if (item_types.includes("Weapon")) {
        return renderWeaponDetails();
      }
    } else {
      if (obj.base_item_types.includes("Armor")) {
        return renderArmorDetails();
      } else if (obj.base_item_types.includes("Weapon")) {
        return renderWeaponDetails();
      }
    }
  }

  const renderArmorDetails = () => {
    return (
      <>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox
            name="Override Proficiency Options" 
            options={ARMOR_TYPE_OPTIONS}
            extra_options={["None"]}
            values={ obj.proficiency_req_options } 
            disabled={disabled}
            multiple
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.proficiency_req_options = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CheckBox 
            value={obj.ignore_stealth_disadvantage} 
            name="Ignore Disadvantage on Stealth"
            disabled={disabled}
            onChange={(value: boolean) => {
              const new_obj = obj;
              new_obj.ignore_stealth_disadvantage = value;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
      </>
    );
  }

  const renderWeaponDetails = () => {
    return (
      <>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            name="Override Proficiency Options" 
            options={WEAPON_KEYWORD_OPTIONS}
            extra_options={["None"]}
            values={ obj.proficiency_req_options } 
            multiple
            disabled={disabled}
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.proficiency_req_options = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectObjectBox 
            name="Proficiency As Weapons" 
            data_type="item"
            filter={{ item_type: "Weapon" }}
            values={ obj.proficiency_as_weapons } 
            multiple
            disabled={disabled}
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.proficiency_as_weapons = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectObjectBox 
            name="Override Weapon Mastery" 
            data_type="weapon_mastery_property"
            extra_options={["Known","None"]}
            value={ obj.weapon_mastery_override === "" ? "None" : obj.weapon_mastery_override } 
            disabled={disabled}
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.weapon_mastery_override = changed === "None" ? "" : changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox
            name="Override Weapon Damage Type"
            options={[...DAMAGE_TYPES,"None"]}
            value={ obj.override_weapon_damage_type === "" ? "None" : obj.override_weapon_damage_type } 
            disabled={disabled}
            onChange={(changed: DamageType | "None") => {
              const new_obj = obj;
              new_obj.override_weapon_damage_type = changed === "None" ? "" : changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }} 
          />
        </Grid>
      </>
    );
  }

  const renderNameOptions = () => {
    // console.log(obj);
    if (obj.min_rarity < obj.max_rarity) {
      const name_rarities = Object.keys(obj.rarity_names).map(o => +o);
      return (
        <>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox
              name="Name Formula"
              value={obj.name_formula}
              disabled={disabled}
              onBlur={(changed: string) => {
                const new_obj = obj;
                new_obj.name_formula = changed;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox
              name="Add Name for Rarity"
              options={RARITY_OPTIONS.filter(o => +o.id >= obj.min_rarity && +o.id <= obj.max_rarity && !name_rarities.includes(+o.id))}
              value={adding_name_for_rarity}
              onChange={setAddingNameForRarity}
            />
          </Grid>
          <Grid
            className="header"
            size={{
              xs: 6
            }}>
            <AddButton
              disabled={disabled || obj.name_formula.length > 0 || adding_name_for_rarity === ""}
              onClick={() => {
                const new_obj = obj;
                new_obj.rarity_names[+adding_name_for_rarity] = obj.name + " " + RARITY_NUM_TO_STR_MAP[+adding_name_for_rarity];
                setAddingNameForRarity("");
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
                setReloading(true);
              }}
            />
          </Grid>
          { !reloading && name_rarities.map((rarity, key) => {
            return (
              <Grid
                key={key}
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 9
                  }}>
                  <StringBox
                    name={`Name for ${RARITY_NUM_TO_STR_MAP[rarity]}`}
                    value={obj.rarity_names[rarity]}
                    disabled={disabled}
                    onBlur={(changed: string) => {
                      const new_obj = obj;
                      new_obj.rarity_names[rarity] = changed;
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 3
                  }}>
                  <DeleteButton
                    disabled={disabled}
                    onClick={() => {
                      const new_obj = obj;
                      delete new_obj.rarity_names[rarity];
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                      setReloading(true);
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        </>
      );
    } else {
      return (
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Name Formula"
            value={obj.name_formula}
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.name_formula = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
      );
    }
    // return null;
  }

  // const getDefaultRecipe = () => {
  //   const recipe = new Recipe();
  //   recipe.name = "Mad HB Default";
  //   let cr = 1;
  //   let item_type = obj.base_item_types[0];
  //   if (obj.base_item_ids.length === 1) {
  //     const item = items.find(o => obj.base_item_ids.includes(o._id));
  //     if (item) {
  //       item_type = item.item_type;
  //     }
  //   }
  //   if (item_type) {
  //     if (item_type === "Ammunition" || item_type === "Consumable" || item_type === "Potion" || item_type === "Poison" || item_type === "Scroll" || item_type === "Dust") {
  //       const rarityToCRMap: { [rarity: number]: number } = {
  //         0: 1, // Common
  //         1: 2, // Uncommon
  //         2: 5, // Rare
  //         3: 8, // Very-Rare
  //         4: 15 // Legendary
  //       }
  //       cr = rarityToCRMap[obj.min_rarity];
  //     } else {
  //       const rarityToCRMap: { [rarity: number]: number } = {
  //         0: 2, // Common
  //         1: 4, // Uncommon
  //         2: 8, // Rare
  //         3: 12, // Very-Rare
  //         4: 18 // Legendary
  //       }
  //       cr = rarityToCRMap[obj.min_rarity];
  //     }
  //     if (cr) {
  //       recipe.cr = cr;
  //       const animus = new RecipeComponent();
  //       animus.component_type = "Animus";
  //       recipe.components.push(animus);
  //       // switch (item_type) {
  //       //   case "Potion":
  //       //     if (true) {
  //       //       const organ = new RecipeComponent();
  //       //       organ.component_type = "Organ"; // or Ash
  //       //       recipe.components.push(organ);
  //       //       const fluid = new RecipeComponent();
  //       //       fluid.component_type = "Fluid";
  //       //       recipe.components.push(fluid);
  //       //     }
  //       //   break;
  //       //   case "Scroll":
  //       //     if (true) {
  //       //       const hide = new RecipeComponent();
  //       //       hide.component_type = "Hide";
  //       //       recipe.components.push(hide);
  //       //       const fluid = new RecipeComponent();
  //       //       fluid.component_type = "Fluid";
  //       //       recipe.components.push(fluid);
  //       //     }
  //       //   break;
  //       // }
  //       const component_count = obj.min_rarity + 2;
  //       while (recipe.components.length < component_count) {
  //         const comp = new RecipeComponent();
  //         recipe.components.push(comp);
  //       }
  //     }
  //     const new_obj = obj;
  //     new_obj.recipes = [recipe];
  //     setObj(new_obj);
  //     setChangeTime(common_util.get_time_number());
  //   }
  // }

  // const saveRecipes = () => {
  //   if (changed_campaign_recipe) {
  //     if (api.user && 
  //       changed_campaign_recipe && 
  //       api.recipes_for_campaign &&
  //       (api.user.admin || 
  //         api.recipes_for_campaign.owner_id === api.user._id)) {
  //       setProcessing(true);
  //       if (changed_campaign_recipe._id === "") {
  //         if (!api.user.admin) {
  //           changed_campaign_recipe.owner_id = api.user._id;
  //         } else {
  //           changed_campaign_recipe.owner_id = "";
  //         }
  //         changed_campaign_recipe.campaign_id = api.recipes_for_campaign._id;
  //         changed_campaign_recipe.for_type = "Magic Item Keyword";
  //         changed_campaign_recipe.for_id = obj._id;
  //       }
  //       api.upsertObject("campaign_recipe", changed_campaign_recipe).then(res => {
  //         if (res && res.body.id) {
  //           changed_campaign_recipe._id = res.body.id;
  //         }
  //         setProcessing(false);
  //         setCampaignRecipe(changed_campaign_recipe);
  //       });
  //     }
  //   }
  // }

  // const resetRecipes = () => {
  //   if (campaign_recipe) {
  //     setChangedCampaignRecipe(campaign_recipe.clone());
  //   }
  // }

  // const renderGetDefault = () => {
  //   if (obj.recipes.length === 0 && (obj.base_item_types.length === 1 || obj.base_item_ids.length === 1)) {
  //     return (
  //       <Grid item xs={12}>
  //         <ButtonBox
  //           name="Get Mad HB Default"
  //           disabled={disabled}
  //           onClick={getDefaultRecipe}
  //         />
  //       </Grid>
  //     );
  //   }
  // }

  const height = window.innerHeight - 110;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else {
    return (
      <FeatureSourceInput 
        obj={obj}
        data_type="magic_item_keyword"
        disabled={disabled}
        change_time={change_time}
        onChange={changed => {
          if (changed instanceof MagicItemKeyword) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}
        extra_menu_options={{"Attributes": 
          <Grid
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            { renderNameOptions() }
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox 
                name="Use Specific Base Item"
                value={obj.uses_specific} 
                disabled={disabled}
                onChange={(value: boolean) => {
                  const new_obj = obj;
                  new_obj.uses_specific = value;
                  setObj(new_obj);
                  setRecalcPossible(true);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            { !obj.uses_specific && 
              <Grid
                size={{
                  xs: 12
                }}>
                <SelectStringBox 
                  name="Item Type" 
                  options={ITEM_TYPES}
                  extra_options={["None"]}
                  auto_sort
                  values={obj.base_item_types} 
                  multiple
                  disabled={disabled}
                  onChange={(values: ItemType[]) => {
                    const new_obj = obj;
                    new_obj.base_item_types = values;
                    setObj(new_obj);
                    setRecalcPossible(true);
                    setChangeTime(common_util.get_time_number());
                  }} 
                />
              </Grid>
            }
            { !obj.uses_specific && obj.base_item_types.includes("Armor") &&
              <Grid
                size={{
                  xs: 12
                }}>
                <SelectArmorTypeBox 
                  name="Armor Types" 
                  multiple
                  values={obj.base_item_details} 
                  disabled={disabled}
                  onChange={(changed: string[]) => {
                    const new_obj = obj;
                    new_obj.base_item_details = changed;
                    setObj(new_obj);
                    setRecalcPossible(true);
                    setChangeTime(common_util.get_time_number());
                  }} 
                />
              </Grid>
            }
            { !obj.uses_specific && obj.base_item_types.includes("Weapon") &&
              <>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <WeaponLimitInput
                    obj={obj.weapon_limit}
                    disabled={disabled}
                    onChange={(changed: WeaponLimitation) => {
                      const new_obj = obj;
                      new_obj.weapon_limit = changed.clone();
                      setObj(new_obj);
                      setRecalcPossible(true);
                      setChangeTime(common_util.get_time_number());
                      // const new_obj = myObj;
                      // new_obj.weapon_limit = changed.clone();
                      // setMyObj(new_obj);
                      // onChange(new_obj);
                    }}
                  />
                  {/* <SelectWeaponKeywordBox 
                    name="Weapon Keywords" 
                    multiple
                    disabled={disabled}
                    values={obj.base_item_details} 
                    onChange={(values: string[]) => {
                      const new_obj = obj;
                      new_obj.base_item_details = values;
                      setObj(new_obj);
                      setRecalcPossible(true);
                      setChangeTime(common_util.get_time_number());
                    }} 
                  /> */}
                </Grid>
              </>
            }
            { obj.uses_specific && 
              <Grid
                size={{
                  xs: 12
                }}>
                <SelectBaseItemBox 
                  name="Base Items" 
                  disabled={disabled}
                  values={obj.base_item_ids} 
                  multiple
                  onChange={(changed: string[]) => {
                    const new_obj = obj;
                    new_obj.base_item_ids = changed;
                    setObj(new_obj);
                    setRecalcPossible(true);
                    setChangeTime(common_util.get_time_number());
                  }} 
                />
              </Grid>
            }
            <Grid
              size={{
                xs: 12
              }}>
              <StringBox 
                name="Exclusions"
                value={obj.exclusions} 
                multiline
                disabled={disabled}
                onBlur={(value: string) => {
                  const new_obj = obj;
                  new_obj.exclusions = value;
                  setObj(new_obj);
                  setRecalcPossible(true);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              <SelectStringBox
                name="Min Rarity"
                options={RARITY_OPTIONS}
                value={`${obj.min_rarity}`}
                disabled={disabled}
                onChange={(changed: string) => {
                  const new_obj = obj;
                  new_obj.min_rarity = +changed;
                  if (new_obj.min_rarity > new_obj.max_rarity) {
                    new_obj.max_rarity = new_obj.min_rarity;
                  }
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              <SelectStringBox
                name="Max Rarity"
                options={RARITY_OPTIONS}
                value={`${obj.max_rarity}`}
                disabled={disabled}
                onChange={(changed: string) => {
                  const new_obj = obj;
                  new_obj.max_rarity = +changed;
                  if (new_obj.min_rarity > new_obj.max_rarity) {
                    new_obj.min_rarity = new_obj.max_rarity;
                  }
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <SelectStringBox
                name="Rarity"
                options={RARITY_OPTIONS}
                disabled={disabled}
                value={`${obj.rarity}`}
                onChange={(value: string) => {
                  const new_obj = obj;
                  new_obj.rarity = +value;
                  setObj(new_obj);
                  setRecalcPossible(true);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid> */}
            { renderDetails() }
            <Grid
              className="header"
              size={{
                xs: 12
              }}>Possible Items</Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <DisplayObjects type="item" ids={possible_base_item_ids} />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox 
                name="Requires Attunement" 
                value={obj.attunement} 
                disabled={disabled}
                onChange={(value: boolean) => {
                  const new_obj = obj;
                  new_obj.attunement = value;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }} 
              />
            </Grid>
            { obj.attunement &&
              <Grid
                container
                spacing={0}
                direction="column"
                size={{
                  xs: 12
                }}>
                <Grid>
                  <span className="header">
                    Limitations
                  </span>
                  { !disabled &&
                    <Tooltip title={`Create New Limitation`}>
                      <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                        onClick={ () => {
                          const new_obj = obj;
                          new_obj.limitations.push(new CharacterLimitation());
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}>
                        <Add/>
                      </Fab>
                    </Tooltip>
                  }
                </Grid>
                { !reloading && obj.limitations.map((limit, key) => {
                  return (
                    <CharacterLimitationBox key={key}
                      obj={limit}
                      disabled={disabled}
                      onChange={() => {
                        setPing(!ping);
                      }}
                      onDelete={() => {
                        const new_obj = obj;
                        new_obj.limitations = obj.limitations.filter(o => o.true_id !== limit.true_id);
                        setObj(new_obj);
                        setChangeTime(common_util.get_time_number());
                        setReloading(true);
                      }}
                    />
                  );
                })}
              </Grid>
            }
            <Grid
              size={{
                xs: 12
              }}>
              <StringBox 
                name="Charges"
                value={`${obj.charges}`} 
                type="number"
                disabled={disabled}
                onBlur={(value: string) => {
                  const new_obj = obj;
                  new_obj.charges = +value;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            { obj.charges > 0 && 
              <Grid
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 3
                  }}>
                  <CheckBox 
                    name="Invert Charges"
                    value={obj.invert_charges}
                    disabled={disabled}
                    onChange={(changed: boolean) => {
                      const new_obj = obj;
                      new_obj.invert_charges = changed;
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
                { !obj.invert_charges && 
                  <>
                    <Grid
                      size={{
                        xs: 3
                      }}>
                      <SelectStringBox 
                        name="Charge Refresh Rule"
                        value={obj.charge_refresh_rule}
                        options={REFRESH_RULES} 
                        disabled={disabled}
                        onChange={(changed: RefreshRuleType) => {
                          const new_obj = obj;
                          new_obj.charge_refresh_rule = changed;
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}
                      />
                    </Grid>
                    <Grid
                      size={{
                        xs: 2
                      }}>
                      <StringBox 
                        name="Dice Count"
                        value={`${obj.refresh_dice_count}`}
                        type="number"
                        disabled={disabled}
                        onBlur={(value: string) => {
                          const new_obj = obj;
                          new_obj.refresh_dice_count = +value;
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}
                      />
                    </Grid>
                    <Grid
                      size={{
                        xs: 2
                      }}>
                      <StringBox 
                        name="Dice Size"
                        value={`${obj.refresh_dice_size}`}
                        type="number"
                        disabled={disabled}
                        onBlur={(value: string) => {
                          const new_obj = obj;
                          new_obj.refresh_dice_size = +value;
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}
                      />
                    </Grid>
                    <Grid
                      size={{
                        xs: 2
                      }}>
                      <StringBox 
                        name="Flat"
                        value={`${obj.refresh_dice_flat}`}
                        type="number"
                        disabled={disabled}
                        onBlur={(value: string) => {
                          const new_obj = obj;
                          new_obj.refresh_dice_flat = +value;
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}
                      />
                    </Grid>
                  </>
                }
              </Grid>
            }
            <Grid
              size={{
                xs: 12
              }}>
              <SelectStringBox 
                name="Extra Base Type"
                value={obj.extra_base_type}
                options={EXTRA_BASE_TYPES}
                disabled={disabled}
                onChange={(changed: ExtraBaseType) => {
                  const new_obj = obj;
                  new_obj.extra_base_type = changed;
                  if (changed === "Spell") { 
                    new_obj.extra_base_limit = new Limitations();
                    new_obj.extra_base_limit.limitation_type = "Spell";
                    new_obj.extra_base_limit.limits.push(new SpellLimitation());
                  } else {
                    new_obj.extra_base_limits = ["Any"];
                  }
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            { renderExtraLimits() }
            { obj.extra_base_type === "Spell" &&
              <Grid
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  <UpgradableNumberBox 
                    name="Spell DC"
                    value={obj.spell_dc}
                    disabled={disabled}
                    onChange={(changed: UpgradableNumber) => {
                      const new_obj = obj;
                      new_obj.spell_dc = changed.clone();
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  <UpgradableNumberBox 
                    name="Spell Attack"
                    value={obj.spell_attack}
                    disabled={disabled}
                    onChange={(changed: UpgradableNumber) => {
                      const new_obj = obj;
                      new_obj.spell_attack = changed.clone();
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  <UpgradableNumberBox 
                    name="Spell Modifier"
                    value={obj.spell_mod}
                    disabled={disabled}
                    onChange={(changed: UpgradableNumber) => {
                      const new_obj = obj;
                      new_obj.spell_mod = changed.clone();
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
              </Grid>
            }
            <Grid
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              <Grid
                size={{
                  xs: 6
                }}>
                <SelectObjectFieldBox
                  name="Environments"
                  data_type="creature"
                  field="environments"
                  extra_options={["Any"]}
                  values={obj.environments}
                  multiple
                  disabled={disabled}
                  onChange={(values: string[]) => {
                    const new_obj = obj;
                    if (values.includes("Any")) {
                      if (new_obj.environments.includes("Any")) {
                        new_obj.environments = values.filter(o => o !== "Any");
                      } else {
                        new_obj.environments = ["Any"];
                      }
                    } else {
                      new_obj.environments = values;
                    }
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 6
                }}>
                {/* <SelectObjectFieldBox
                  name="Settings"
                  data_type="creature"
                  field="settings"
                  extra_options={["Any"]}
                  values={obj.settings}
                  multiple
                  disabled={disabled}
                  onChange={(values: string[]) => {
                    const new_obj = obj;
                    if (values.includes("Any")) {
                      if (new_obj.settings.includes("Any")) {
                        new_obj.settings = values.filter(o => o !== "Any");
                      } else {
                        new_obj.settings = ["Any"];
                      }
                    } else {
                      new_obj.settings = values;
                    }
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                /> */}
              </Grid>
            </Grid>
          </Grid>,
          // "Recipes":
          // <Grid item xs={12} container spacing={0} direction="row">
          //   { renderGetDefault() }
          //   { obj._id !== "" && api.recipes_for_campaign && 
          //     <Grid item xs={12}>
          //       <CenteredMenu
          //         options={["Standard","Campaign"]}
          //         selected={recipe_view}
          //         onSelect={setRecipeView}
          //       />
          //     </Grid>
          //   }
          //   { recipe_view === "Standard" ? 
          //     <Grid item xs={12}>
          //       <RecipesInput
          //         recipes={obj.recipes}
          //         item_id={obj._id}
          //         disabled={disabled}
          //         onChange={(changed: Recipe[]) => {
          //           const new_obj = obj;
          //           new_obj.recipes = changed;
          //           setObj(new_obj);
          //           setChangeTime(common_util.get_time_number());
          //         }}
          //       />
          //     </Grid>
          //   : changed_campaign_recipe &&
          //     <>
          //       <Grid item xs={12}>
          //         <ToggleButtonBox
          //           name="Use Standard"
          //           value={using_standard}
          //           onToggle={() => { setUsingStandard(!using_standard); }}
          //         />
          //       </Grid>
          //       { using_standard ? 
          //         <Grid item xs={12}>
          //           <SelectRecipeIndex
          //             mik={obj}
          //             onUse={(changed: Recipe) => {
          //               const new_obj = changed_campaign_recipe;
          //               const clone = changed.clone();
          //               clone.name += " Copied from Standard";
          //               new_obj.recipes.push(clone);
          //               setChangedCampaignRecipe(new_obj);
          //               setChangeTime(common_util.get_time_number());
          //               setUsingStandard(false);
          //             }}
          //           />
          //         </Grid>
          //       :
          //         <>
          //           <Grid item xs={12}>
          //             <RecipesInput
          //               recipes={changed_campaign_recipe.recipes}
          //               item_id={obj._id}
          //               disabled={disabled}
          //               onChange={(changed: Recipe[]) => {
          //                 const new_obj = changed_campaign_recipe;
          //                 new_obj.recipes = changed;
          //                 setChangedCampaignRecipe(new_obj);
          //                 setChangeTime(common_util.get_time_number());
          //               }}
          //             />
          //           </Grid>
          //           <Grid item xs={12}>
          //             <Button
          //               variant="contained"
          //               color="primary"
          //               disabled={ processing }
          //               onClick={saveRecipes}>
          //               Save Recipes
          //             </Button>
          //             <Button
          //               variant="contained"
          //               disabled={processing}
          //               style={{ marginLeft: "4px" }}
          //               onClick={ () => { 
          //                 resetRecipes();
          //               }}>
          //               Cancel
          //             </Button>
          //           </Grid>
          //         </>
          //       }
          //     </>
          //   }
          // </Grid>
        }}
      />
    );
  }
}
